import React from "react";
import {
  Dialog as MuiDialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
  makeStyles,
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import tokens from "../designTokens";

const useStyles = makeStyles({
  head: { display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, padding: "16px 20px" },
  title: { fontFamily: tokens.fontHeading, fontWeight: 600, fontSize: 17, color: tokens.textPrimary },
  actions: { padding: "12px 20px" },
});

export default function Dialog({ open, title, children, footer, onClose, width = 480 }) {
  const classes = useStyles();
  return (
    <MuiDialog open={!!open} onClose={onClose} PaperProps={{ style: { width, maxWidth: "100%" } }}>
      <DialogTitle disableTypography className={classes.head}>
        <Typography component="div" className={classes.title}>{title}</Typography>
        <IconButton size="small" aria-label="Close" onClick={onClose}>
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>{children}</DialogContent>
      {footer && <DialogActions className={classes.actions}>{footer}</DialogActions>}
    </MuiDialog>
  );
}
